import { styled } from '@mui/material';
import TreeItemCustom from '../../../../components/TreeItemCustom';

const StyledTreeItemCustom = styled(TreeItemCustom)(() => ({
  fontSize: 14,
  '.MuiTreeItem-root': { marginLeft: '13px' },
}));

export default StyledTreeItemCustom;
